import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import widgetUtil       from 'util/WidgetUtil.js';

import { View } from 'backbone';

import formatTemplate from 'properties/main/after-submission.ejs';


class MainAfterSubmission extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[name="closeOption"]' : 'updateAttributes'
        };

        // Add needed property
        if (!this.model.get('closeOption')) {
            this.model.set('closeOption','default', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal, {silent: true} );
        this.model.set('widgetText', widgetUtil.getWidgetText(this.model) ) ;
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(`input[value=${this.model.get('closeOption')}]`).prop('checked',true);
        const option = $(`input[value=${this.model.get('closeOption')}]`);

        this.delegateEvents();
        // console.log(this);
        return this;
    }

}

export default MainAfterSubmission;
